module.exports = __webpack_public_path__ + "static/media/face_dn_2_isometrico_icono.c3e87073.png";